export default __webpack_public_path__ + "static/media/dropdown.221da7a4.svg";